export class DeviceDetector {
  static isTV() {
    const ua = navigator.userAgent.toLowerCase();

    const tvKeywords = [
      'tv',
      'smart-tv',
      'smarttv',
      'television',
      'netcast',
      'nettv',
      'appletv',
      'googletv',
      'webos',
      'tizen',
    ];

    const isTVUserAgent = tvKeywords.some((keyword) => ua.includes(keyword));

    const screenChecks = {
      isLandscape: window.screen.width > window.screen.height,
      isLargeScreen: window.screen.width >= 1920 && window.screen.height >= 1080,
      hasLimitedInput: !('ontouchstart' in window) && !('onmousemove' in window),
    };

    return (
      isTVUserAgent ||
      (screenChecks.isLargeScreen && screenChecks.hasLimitedInput && screenChecks.isLandscape)
    );
  }

  static isHighResolution() {
    return window.screen.width >= 1920 && window.screen.height >= 1080;
  }

  static isRemoteControlLikely() {
    return !('ontouchstart' in window) && !('onmousemove' in window);
  }

  static async getTVOptimizedSettings() {
    const isTV = this.isTV();
    return {
      isTV,
      shouldUseLargeUI: isTV || this.isHighResolution(),
      shouldOptimizeForRemote: isTV || this.isRemoteControlLikely(),
    };
  }
}
